import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const InitiativeTypeLabel = () => {
   const theme = useContext(ThemeContext)
   const { initiative } = useContext(InitiativeHierarchyContext)

   return (
      <div
         style={{
            display: 'inline-block',
            margin: 0,
            padding: 0
         }}>
         <View display="flex" alignItems="center" height="25px" marginBottom="10px">
            <Text
               color="#888"
               size={theme.tmpBodyTextSize}>
               {initiative.type.namePlural}
            </Text>
            {initiative.pinned && (
               <View
                  display="flex"
                  alignItems="center"
                  border="1px solid rgba(150,150,150,0.5)"
                  padding="3px 6px"
                  borderRadius="3px"
                  marginLeft="12px">
                  <Text size="0.8" weight="bold" transform="uppercase" color="#888">
                     Pinned
                  </Text>
               </View>
            )}
            {initiative.archived && (
               <View
                  display="flex"
                  alignItems="center"
                  border="1px solid rgba(150,150,150,0.5)"
                  padding="3px 6px"
                  borderRadius="3px"
                  marginLeft="12px">
                  <Text size="0.8" weight="bold" transform="uppercase" color="#888">
                     Archived
                  </Text>
               </View>
            )}
         </View>
      </div>
   )
}

export default InitiativeTypeLabel
